import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const DetailAddonInfoMask = styled.div<React.CSSProperties>`
  position: fixed;
  background: linear-gradient(0deg, rgb(0, 0, 0) 5%, rgba(0, 0, 0, 0) 25%);
  width: 100%;
  height: 64%;
  top: -${Screen.widthRatio * -24}px;
`;

export default DetailAddonInfoMask;
